import React, { useContext, useState } from 'react'
import axios from 'axios'
import Popup from 'reactjs-popup'

import UserContext from '../context/UserContext'

const AUDIENCES = {
  fitter: {
    fee: 'monthly Fitter Management fee',
    relyers: 'fitters',
    priceChange: 'increase to $65 per month (previously $45)'
  },
  apprentice: {
    fee: 'monthly Apprentice Management fee',
    relyers: 'apprentices',
    priceChange: 'increase to $250 per month (previously $195)'
  },
  ctp: {
    fee: 'CTP Management fee',
    relyers: 'CTPs',
    priceChange: 'transition to a $5,000 fee covering a full two-year contract'
  }
}

const getAudience = (user) => {
  if (!user || user.isSuper || user.isNonSub) return null
  if (user.isAdmin) return 'ctp'
  const classification = user.classification || ''
  if (classification.includes('fitter')) return 'fitter'
  if (user.isApprentice || classification.includes('apprentice')) return 'apprentice'
  return null
}

const PriceChangeAckModal = () => {
  const { userData, setUserData } = useContext(UserContext)
  const [submitting, setSubmitting] = useState(false)

  const user = userData?.user
  const audience = getAudience(user)
  const open = !!userData?.userId && user?.priceAcked === false && !!audience
  const copy = AUDIENCES[audience]

  const acknowledge = async () => {
    setSubmitting(true)
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/2.0/user/price-ack`)
    setSubmitting(false)
    if (res?.status !== 200) return
    setUserData(prev => ({ ...prev, user: { ...prev.user, priceAcked: true } }))
  }

  return (
    <Popup
      modal
      open={open}
      closeOnDocumentClick={false}
      closeOnEscape={false}
      lockScroll
      contentStyle={{ width: '90%', maxWidth: '500px' }}
    >
      <div className="form-background popup-scrollable">
        <p className="h3">Notice:</p>
        <p className="my-4">
          Effective January 2027, the {copy?.fee} will {copy?.priceChange}. This is ACT’s first price increase in five years and will allow us to continue providing the compliance and administrative support our {copy?.relyers} rely on.
        </p>
        <p className="my-4">
          If you have questions, please call the ACT office during business hours, Monday–Friday, 9 AM–6 PM.
        </p>
        <p className="my-4">
          You can reach our office at:
          <br />
          (951) 221-3405
        </p>
        <p className="my-4">Thank you for your continued support!</p>
        <button className="button is-link" onClick={acknowledge} disabled={submitting}>
          I Acknowledge
        </button>
      </div>
    </Popup>
  )
}

export default PriceChangeAckModal
